module.exports = __webpack_public_path__ + "static/media/西部微视.8e82066d.jpg";